import { render, staticRenderFns } from "./AuthedPwChange.vue?vue&type=template&id=61e58202&scoped=true"
import script from "./AuthedPwChange.vue?vue&type=script&lang=js"
export * from "./AuthedPwChange.vue?vue&type=script&lang=js"
import style0 from "./AuthedPwChange.vue?vue&type=style&index=0&id=61e58202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e58202",
  null
  
)

export default component.exports